import React, { useState, useEffect, useRef } from "react";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import config from "../../config";
import AdminSearch from "../../components/AdminSearch";

export default function Audio() {
  const [contents, setContents] = useState([]);
  const [recordToDelete, setRecordToDelete] = useState(null); // State to track the record to delete
  const [recordToEdit, setRecordToEdit] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showResults, setShowResults] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);

  const resultRef = useRef(null);

  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();

    if (searchQuery.length < 3) {
      setErrorMessage("لطفاً کلمات درست را وارد نمایید");
      setShowError(true);
      setShowResults(false);
      setTimeout(() => {
        setShowError(false);
        setErrorMessage("");
      }, 5000);
      return;
    }

    // Send a GET request to the PHP backend with the search query
    fetch(
      `${config.apiUrl}contentapi.php?option=1&type=14&category=audio&strsearch=${searchQuery}`
    )
      .then((response) => response.json())
      .then((data) => {
        setSearchResults(data);
        setShowResults(true); // Show the results when available
        setShowError(false);

        if (data.length === 0) {
          setErrorMessage("نتیجه‌ای دریافت نشد");
          setShowError(true);
          setShowResults(false);
          setTimeout(() => {
            setShowError(false);
            setErrorMessage("");
          }, 5000);
          return;
        }
      })
      .catch((error) => {
        console.error("Error fetching search results:", error);
        setErrorMessage("Error fetching search results");
        setShowError(true);

        // Hide the response message after 5 seconds
        setTimeout(() => {
          setShowError(false);
          setErrorMessage("");
        }, 5000);
      });
  };

  const fetchData = async () => {
    if (!hasMore) return;

    setIsLoading(true);

    try {
      const response = await fetch(
        `${config.apiUrl}lazyLoad.php?option=1&categoryid=2&subcategory=0&page=${page}`
      );
      const data = await response.json();

      // Extract the list of contents from the API response
      const newContents = data.map((item) => ({
        id: item.id,
        Title: item.Title,
        CategoryD: item.CategoryD,
        categoryE: item.CategoryE,
        SubCategory: item.SubCategory,
        SubCategoryd: item.SubCategoryd,
        ShortDesc: item.ShortDesc,
        PostDate: item.PostDate,
        StatusId: item.StatusId,
        contentViews: item.contentViews,
        LanguageId: item.LanguageId,
        ImageUrl: item.ImageUrl,
        audioUrl: item.audioUrl,
      }));

      setContents([...contents, ...newContents]);
      setPage(page + 1);
      setHasMore(newContents.length > 0);
    } catch (error) {
      console.error("Error fetching data:", error);
      setErrorMessage("Error fetching search results");
      setShowError(true);

      // Hide the response message after 5 seconds
      setTimeout(() => {
        setShowError(false);
        setErrorMessage("");
      }, 5000);
    } finally {
      setIsLoading(false);
    }
  };

  const loadMore = () => {
    fetchData();
  };

  useEffect(() => {
    fetchData(); // Initial data fetch
  }, []);

  // TODO: change the bellow code from scroll to click
  useEffect(() => {
    window.addEventListener("scroll", loadMore);

    return () => {
      window.removeEventListener("scroll", loadMore);
    };
  }, [page]);

  // Function to handle the deletion of a record
  const handleDelete = (record) => {
    setRecordToDelete(record); // Set the record to be deleted
  };

  // Function to confirm and delete the record
  const confirmDelete = async () => {
    try {
      // Make an API call to delete the record
      const response = await fetch(`${config.apiUrl}deleterecord.php?type=1`, {
        method: "POST",
        body: JSON.stringify({ id: recordToDelete.id }), // Assuming your record has an 'id' property
        credentials: "include",
      });

      if (response.ok) {
        const updatedContents = contents.filter(
          (record) => record !== recordToDelete
        );
        setContents(updatedContents);
        setRecordToDelete(null); // Reset the record to be deleted
      } else {
        // Handle the case where the deletion fails
        console.error("Deletion failed");
      }
    } catch (error) {
      console.error("Error deleting record:", error);
    }
  };

  const handleEdit = (record) => {
    setRecordToEdit(record); // Set the record to be edited
  };

  // Function to save the edited record
  const saveEditedRecord = async () => {
    try {
      const response = await fetch(`${config.apiUrl}editapi.php?type=4`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(recordToEdit),
        credentials: "include",
      });

      if (response.ok) {
        // If the API request is successful, update the state with the edited record
        const updatedContents = contents.map((record) => {
          if (record.id === recordToEdit.id) {
            return recordToEdit; // Replace the existing record with the edited one
          }
          return record;
        });
        setContents(updatedContents);
        setRecordToEdit(null); // Reset the record being edited
      } else {
        console.error("Failed to update the record");
      }
    } catch (error) {
      console.error("Error updating record:", error);
    }
  };

  const searchResultList = searchResults.map((audio) => (
    <tr key={audio.id}>
      <td>{audio.Title}</td>
      <td>{audio.SubCategoryd}</td>
      <td>{parseInt(audio.LanguageId) === 1 ? "دری" : "پشتو"}</td>
      <td>{audio.PostDate}</td>
      <td>
        {parseInt(audio.StatusId) === 1 ? (
          <small className="btn btn-success btn-sm">بلی</small>
        ) : (
          <small className="btn btn-secondary btn-sm">نخیر</small>
        )}
      </td>
      <td className="d-flex gap-2">
        {/* Edit button and modal */}
        <button
          type="button"
          className="btn btn-sm btn-warning rounded"
          onClick={() => handleEdit(audio)}
          data-bs-toggle="modal"
          data-bs-target="#audioEditModal"
        >
          <AiOutlineEdit />
        </button>
        <div
          className="modal fade"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          id="audioEditModal"
          tabIndex="-1"
          aria-labelledby="audioEditModalLabel"
          aria-hidden="true"
          dir="ltr"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="audioEditModalLabel">
                  ویرایش ریکارد
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form dir="rtl">
                  <div className="form-group row g-3">
                    <div className="col-lg-6">
                      <label htmlFor="Title" className="form-label">
                        Title
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="Title"
                        name="Title"
                        value={recordToEdit ? recordToEdit.Title : ""}
                        onChange={(e) =>
                          setRecordToEdit({
                            ...recordToEdit,
                            Title: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                    <div className="col-lg-6">
                      <label htmlFor="StatusId" className="form-label">
                        Publish
                      </label>
                      <select
                        name="StatusId"
                        className="form-select"
                        value={recordToEdit ? recordToEdit.StatusId : ""}
                        onChange={(e) =>
                          setRecordToEdit({
                            ...recordToEdit,
                            StatusId: e.target.value,
                          })
                        }
                        required
                      >
                        <option>Select publish status</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                    <div className="col-lg-12">
                      <label htmlFor="ShortDesc" className="form-label">
                        Short Description
                      </label>
                      <textarea
                        className="form-control"
                        rows={3}
                        name="ShortDesc"
                        id="ShortDesc"
                        value={recordToEdit ? recordToEdit.ShortDesc : ""}
                        onChange={(e) =>
                          setRecordToEdit({
                            ...recordToEdit,
                            ShortDesc: e.target.value,
                          })
                        }
                        required
                      ></textarea>
                    </div>
                    <div className="col-lg-6">
                      <label htmlFor="ImageUrl" className="form-label">
                        Image
                      </label>
                      <input
                        dir="ltr"
                        type="text"
                        className="form-control"
                        id="ImageUrl"
                        name="ImageUrl"
                        value={recordToEdit ? recordToEdit.ImageUrl : ""}
                        onChange={(e) =>
                          setRecordToEdit({
                            ...recordToEdit,
                            ImageUrl: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                    <div className="col-lg-6">
                      <label htmlFor="audioUrl" className="form-label">
                        Audio link
                      </label>
                      <input
                        dir="ltr"
                        type="text"
                        className="form-control"
                        id="audioUrl"
                        name="audioUrl"
                        value={recordToEdit ? recordToEdit.audioUrl : ""}
                        onChange={(e) =>
                          setRecordToEdit({
                            ...recordToEdit,
                            audioUrl: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                    {/* Other form fields with onChange handlers */}
                    <div className="col-lg-6">
                      <label htmlFor="LanguageId" className="form-label">
                        Language
                      </label>
                      <select
                        name="LanguageId"
                        className="form-select"
                        value={recordToEdit ? recordToEdit.LanguageId : ""}
                        onChange={(e) =>
                          setRecordToEdit({
                            ...recordToEdit,
                            LanguageId: e.target.value,
                          })
                        }
                        required
                      >
                        <option>Select a language</option>
                        <option value="1">Dari</option>
                        <option value="2">Pashto</option>
                      </select>
                    </div>
                    <div className="col-lg-6">
                      <label htmlFor="PostDate" className="form-label">
                        Date
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="PostDate"
                        name="PostDate"
                        value={recordToEdit ? recordToEdit.PostDate : ""}
                        onChange={(e) =>
                          setRecordToEdit({
                            ...recordToEdit,
                            PostDate: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  لغو
                </button>
                <button
                  type="button"
                  onClick={saveEditedRecord}
                  className="btn btn-warning"
                  data-bs-dismiss="modal"
                >
                  ذخیره تغییرات
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Delete Button and modal */}
        <button
          type="button"
          className="btn btn-sm btn-danger rounded"
          data-bs-toggle="modal"
          data-bs-target="#audioDeleteModal"
          onClick={() => handleDelete(audio)}
        >
          <AiOutlineDelete />
        </button>
        <div
          className="modal fade"
          id="audioDeleteModal"
          tabIndex="-1"
          aria-labelledby="audioDeleteModalLabel"
          aria-hidden="true"
          dir="ltr"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="audioDeleteModalLabel">
                  حذف ریکارد
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body" dir="rtl">
                آیا مطمئن هستید که حذف شود؟
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  لغو
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={confirmDelete}
                  data-bs-dismiss="modal"
                >
                  حذف شود
                </button>
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
  ));

  const allAudios = contents.map((audio) => (
    <tr key={audio.id}>
      <td>{audio.Title}</td>
      <td>{audio.SubCategoryd}</td>
      <td>{parseInt(audio.LanguageId) === 1 ? "دری" : "پشتو"}</td>
      <td>{audio.PostDate}</td>
      <td>
        {parseInt(audio.StatusId) === 1 ? (
          <small className="btn btn-success btn-sm">بلی</small>
        ) : (
          <small className="btn btn-secondary btn-sm">نخیر</small>
        )}
      </td>
      <td className="d-flex gap-2">
        {/* Edit button and modal */}
        <button
          type="button"
          className="btn btn-sm btn-warning rounded"
          onClick={() => handleEdit(audio)}
          data-bs-toggle="modal"
          data-bs-target="#audioEditModal"
        >
          <AiOutlineEdit />
        </button>
        <div
          className="modal fade"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          id="audioEditModal"
          tabIndex="-1"
          aria-labelledby="audioEditModalLabel"
          aria-hidden="true"
          dir="ltr"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="audioEditModalLabel">
                  ویرایش ریکارد
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form dir="rtl">
                  <div className="form-group row g-3">
                    <div className="col-lg-6">
                      <label htmlFor="Title" className="form-label">
                        Title
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="Title"
                        name="Title"
                        value={recordToEdit ? recordToEdit.Title : ""}
                        onChange={(e) =>
                          setRecordToEdit({
                            ...recordToEdit,
                            Title: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                    <div className="col-lg-6">
                      <label htmlFor="StatusId" className="form-label">
                        Publish
                      </label>
                      <select
                        name="StatusId"
                        className="form-select"
                        value={recordToEdit ? recordToEdit.StatusId : ""}
                        onChange={(e) =>
                          setRecordToEdit({
                            ...recordToEdit,
                            StatusId: e.target.value,
                          })
                        }
                        required
                      >
                        <option>Select publish status</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                    <div className="col-lg-12">
                      <label htmlFor="ShortDesc" className="form-label">
                        Short Description
                      </label>
                      <textarea
                        className="form-control"
                        rows={3}
                        name="ShortDesc"
                        id="ShortDesc"
                        value={recordToEdit ? recordToEdit.ShortDesc : ""}
                        onChange={(e) =>
                          setRecordToEdit({
                            ...recordToEdit,
                            ShortDesc: e.target.value,
                          })
                        }
                        required
                      ></textarea>
                    </div>
                    <div className="col-lg-6">
                      <label htmlFor="ImageUrl" className="form-label">
                        Image
                      </label>
                      <input
                        dir="ltr"
                        type="text"
                        className="form-control"
                        id="ImageUrl"
                        name="ImageUrl"
                        value={recordToEdit ? recordToEdit.ImageUrl : ""}
                        onChange={(e) =>
                          setRecordToEdit({
                            ...recordToEdit,
                            ImageUrl: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                    <div className="col-lg-6">
                      <label htmlFor="audioUrl" className="form-label">
                        Audio link
                      </label>
                      <input
                        dir="ltr"
                        type="text"
                        className="form-control"
                        id="audioUrl"
                        name="audioUrl"
                        value={recordToEdit ? recordToEdit.audioUrl : ""}
                        onChange={(e) =>
                          setRecordToEdit({
                            ...recordToEdit,
                            audioUrl: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                    {/* Other form fields with onChange handlers */}
                    <div className="col-lg-6">
                      <label htmlFor="LanguageId" className="form-label">
                        Language
                      </label>
                      <select
                        name="LanguageId"
                        className="form-select"
                        value={recordToEdit ? recordToEdit.LanguageId : ""}
                        onChange={(e) =>
                          setRecordToEdit({
                            ...recordToEdit,
                            LanguageId: e.target.value,
                          })
                        }
                        required
                      >
                        <option>Select a language</option>
                        <option value="1">Dari</option>
                        <option value="2">Pashto</option>
                      </select>
                    </div>
                    <div className="col-lg-6">
                      <label htmlFor="PostDate" className="form-label">
                        Date
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="PostDate"
                        name="PostDate"
                        value={recordToEdit ? recordToEdit.PostDate : ""}
                        onChange={(e) =>
                          setRecordToEdit({
                            ...recordToEdit,
                            PostDate: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  لغو
                </button>
                <button
                  type="button"
                  onClick={saveEditedRecord}
                  className="btn btn-warning"
                  data-bs-dismiss="modal"
                >
                  ذخیره تغییرات
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Delete Button and modal */}
        <button
          type="button"
          className="btn btn-sm btn-danger rounded"
          data-bs-toggle="modal"
          data-bs-target="#audioDeleteModal"
          onClick={() => handleDelete(audio)}
        >
          <AiOutlineDelete />
        </button>
        <div
          className="modal fade"
          id="audioDeleteModal"
          tabIndex="-1"
          aria-labelledby="audioDeleteModalLabel"
          aria-hidden="true"
          dir="ltr"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="audioDeleteModalLabel">
                  حذف ریکارد
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body" dir="rtl">
                آیا مطمئن هستید که حذف شود؟
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  لغو
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={confirmDelete}
                  data-bs-dismiss="modal"
                >
                  حذف شود
                </button>
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
  ));

  return (
    <div className="bg-body" style={{ fontSize: "smaller" }}>
      <div className="max-container-width py-3 text-body">
        <AdminSearch
          handleSearchSubmit={handleSearchSubmit}
          searchQuery={searchQuery}
          handleSearchInputChange={handleSearchInputChange}
          setShowResults={setShowResults}
          resultRef={resultRef}
        />

        {showError && (
          <div className="alert alert-danger" role="alert">
            {errorMessage}
          </div>
        )}

        <table className="table" dir="rtl">
          <thead>
            <tr>
              <th scope="col">Title</th>
              <th scope="col">Subcategory</th>
              <th scope="col">Language</th>
              <th scope="col">Date</th>
              <th scope="col">Published</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {searchResults.length > 0 && searchQuery.length > 0
              ? searchResultList
              : allAudios}
          </tbody>
        </table>

        {hasMore && !isLoading && !searchQuery && (
          <div className="text-center mt-5">
            <button
              type="button"
              className="btn btn-sm btn-secondary rounded"
              id="loadmore"
              onClick={() => loadMore()}
            >
              مطالب بیشتر
            </button>
          </div>
        )}

        {!hasMore && !isLoading && (
          <div className="mt-5 text-center">
            <small className="p-2 bg-secondary text-light rounded">
              پایان مطالب
            </small>
          </div>
        )}

        {isLoading && (
          <div className="d-flex justify-content-center">
            <div
              className="spinner-border primary-text-blue"
              dir="ltr"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
